<footer id="mainFooter">
  <div class="container" style="max-width: 90% !important">
    <!-- <div class="col-sm-12 col-md-12 col-xs-12"> -->
    <div class="col-sm-12 col-md-12 col-xs-12">
      <div class="mainFooter-top">
        <div class="main-wrapper">
          <div class="mainFooter-feature gtm-footer">
            <div class="feature contact-panel">
              <a href="#">
                <img
                  width="240px"
                  [src]="CompanyLogo"
                  alt="optimum"
                  class="brand-logo hidden-xs" />
              </a>
              <ul class="socialLinks-list d-none">
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="twitter">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/Google_Colorful.svg"
                      alt="twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="youtube">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/youtube-icon.svg"
                      alt="youtube" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="twitter">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/WhatsApp_Color.svg"
                      alt="twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="Telegram">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/telegram-icon.svg"
                      alt="telegram" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="linkedin">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/linkedin-icon.svg"
                      alt="linkedin" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="facebook">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/facebook-icon.svg"
                      alt="facebook" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="twitter">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../assets/images/img/socialicons/twitter-icon.svg"
                      alt="twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    target="_self"
                    rel="nofollow noopener"
                    title="instagram">
                    <img
                      width="22"
                      height="22"
                      class="icon scaleAnimation"
                      src="../../../../assets/images/img/socialicons/instagram.png"
                      alt="instagram" />
                  </a>
                </li>
              </ul>
            </div>
            <div class="feature">
              <strong class="feature-title">Contact</strong>
              <div class="feature-content">
                <ul class="contactInfo-list">
                  <li>
                    <img
                      class="icon"
                      src="../../../assets/images/img/contacticon/Frame 13.svg"
                      alt="email" />
                    <span target="_self" title="">{{ mailtext }}</span>
                    <!--[href]="Companyemail"-->
                  </li>
                  <li>
                    <img
                      class="icon"
                      src="../../../assets/images/img/contacticon/Frame 12.svg"
                      alt="email" />
                    <span target="_self" title="">{{ footercontacttext }}</span>
                    <!--[href]="footercontactlink"-->
                  </li>
                  <li>
                    <img
                      class="icon"
                      src="../../../assets/images/img/contacticon/Frame 14.svg"
                      alt="email" />
                    <span target="_self" title="">
                      <!--[href]="footeraddreslink"-->
                      {{ footeraddresstext }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="featur5">
              <strong class="feature-title">Explore MF</strong>
              <div class="feature-content">
                <ul class="nav-list">
                  <li>
                    <a href="mf/Types_Of_MF" title="">Types of Mutual Funds</a>
                  </li>
                  <li>
                    <a href="mf/Advantages_Of_MutualFundsComponent" title="">
                      Advantages of MF
                    </a>
                  </li>
                  <li>
                    <a href="mf/categorization-of-mutual-funds" title="">
                      Categorisation of MFs
                    </a>
                  </li>
                  <li>
                    <a href="mf/FAQ" title="">Myths & Facts about MF</a>
                  </li>
                  <li>
                    <a href="mf/FAQ" title="">Frequently Asked Questions</a>
                  </li>
                </ul>
                <br />
                <!-- <strong class="feature-title"><a routerLinkActive="Active" routerLink="/privacy_policy">Privacy Policy</a></strong> -->
              </div>
            </div>

            <!-- <div class="featur5">
                      <strong class="feature-title">Download App</strong>
                      <div class="feature-content">
                        <ul class="nav-list">
                          <li>
                            <img style="height:125px !important;" class="img-fluid" alt="Optimum mobile app showcase"
                            [src]="UploadedQR" />
                          </li>
                          <li>
                              <a [href]="Googleplaylink" target="_blank">
                                <img src="../../assets/images/img/MobileAppDownload.png" class="MobilAppimg" style="height: 38px !important;" />
                              </a>
                        </li>

                        </ul>
                        <br>
                      </div>
                    </div> -->

            <div class="featur5">
              <strong class="feature-title">WhatsApp</strong>
              <div class="feature-content">
                <ul class="nav-list">
                  <li>
                    <img
                      style="height: 125px !important"
                      class="img-fluid"
                      alt="Optimum mobile app showcase"
                      [src]="WhatsAppQR" />
                  </li>
                  <li>
                    <a [href]="WhatsAppLink" target="_blank">
                      <img
                        src="../../assets/images/img/ConnectOnWhatsApp.png"
                        class="MobilAppimg"
                        style="height: 38px !important" />
                    </a>
                  </li>
                </ul>
                <br />
                <!-- <strong class="feature-title"><a routerLinkActive="Active" routerLink="/privacy_policy">Privacy Policy</a></strong> -->
              </div>
            </div>
          </div>
          <!-- <div class="copyright-block">
                        <div class="downloadApp-block order-2">
                            <span class="title">Download Mobile Apps</span>
                            <ul class="downloadApp-list">
                                <li>
                                    <a href="https://Optimum.onelink.me/unJQ/36bea381" target="_self" rel="nofollow noopener" title="play store icon">
                                        <img width="176" height="52" src="https://static.smartspends.com/static/images/Optimumweb/google-icon.svg" alt="play store icon" class="icon scaleAnimation">
                                    </a>
                                </li>
                                <li>
                                    <a href="https://Optimum.onelink.me/unJQ/33aa78d8" target="_self" rel="nofollow noopener" title="ios icon">
                                        <img width="156" height="52" src="https://static.smartspends.com/static/images/Optimumweb/ios-icon.svg" alt="ios icon" class="icon scaleAnimation">
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <span class="order-1 copyright-text">©Copyright 2021optimumfintech.com All Rights Reserved</span>
                    </div> -->
        </div>
      </div>
      <div class="mainFooter-bottom MobileHide">
        <div class="feature contact-panel">
          <ul class="socialLinks-list">
            <li>
              <a
                [href]="WhatsAppLink"
                target="_blank"
                rel="nofollow noopener"
                title="WhatsApp">
                <img
                  width="24"
                  height="24"
                  class="icon scaleAnimation"
                  src="../../../assets/images/img/socialicons/WhatsApp-icon.svg"
                  alt="WhatsApp" />
              </a>
            </li>

            <li>
              <a
                [href]="LinkedInLink"
                target="_blank"
                rel="nofollow noopener"
                title="linkedin">
                <img
                  width="24"
                  height="24"
                  class="icon scaleAnimation"
                  src="../../../assets/images/img/socialicons/linkedin-icon.svg"
                  alt="linkedin" />
              </a>
            </li>
            <li>
              <a
                [href]="FacebookLink"
                target="_blank"
                rel="nofollow noopener"
                title="facebook">
                <img
                  width="24"
                  height="24"
                  class="icon scaleAnimation"
                  src="../../../assets/images/img/socialicons/facebook-icon.svg"
                  alt="facebook" />
              </a>
            </li>
            <li>
              <a
                [href]="TwitterLink"
                target="_blank"
                rel="nofollow noopener"
                title="twitter">
                <img
                  width="24"
                  height="24"
                  class="icon scaleAnimation"
                  src="../../../assets/images/img/socialicons/twitter-icon.svg"
                  alt="twitter" />
              </a>
            </li>
            <li>
              <a
                [href]="InstagramLink"
                target="_blank"
                rel="nofollow noopener"
                title="instagram">
                <img
                  width="24"
                  height="24"
                  class="icon scaleAnimation"
                  src="../../../../assets/images/img/socialicons/instagram-icon.svg"
                  alt="instagram" />
              </a>
            </li>
          </ul>
        </div>
        <div class="main-wrapper">
          <!-- <p> AMFI Registered Mutual Fund Distributor  |  ARN - {{item.ARNNo}}</p> -->

          <p>
            Mutual Fund Disclaimer: Mutual fund investments are subject to
            market risks. Read all scheme related documents carefully.
          </p>
          <p>
            AMFI Registered Mutual Fund Distributor | {{ ARNNo }} | Initial Date
            of ARN Registration : {{ FromDate }} | Validity Expiry of ARN :
            {{ ToDate }}
          </p>

          <p class="disclaimer-text hide">
            Mutual fund investments are subject to market risks. Read all scheme
            related documents carefully.
          </p>

          <p class="licenseNo hide">
            AMFI Registered Mutual Fund Distributor | {{ ARNNo }}
          </p>
          <address class="mb-0">
            Content Disclaimer: The information on Mutual Funds available on
            this platform is sourced from AMFI.
          </address>
          <!-- <address>Mutual Fund investments are subject to market risks. Read all scheme related documents carefully. Past performance of any scheme does not indicate its future performance.</address> -->
          <address>
            <p class="licenseNo Privacy">
              <a
                class="licenseNo Privacy"
                routerLinkActive="Active"
                routerLink="/disclaimer">
                Disclaimer
              </a>
              |
              <a
                class="licenseNo Privacy"
                routerLinkActive="Active"
                routerLink="/privacy_policy">
                Privacy Policy
              </a>
            </p>
          </address>
        </div>
      </div>
    </div>

    <div class="mainFooter-bottom">
      <div class="mainFooter-bottom desktopHide">
        <div class="main-wrapper">
          <p>
            Mutual fund investments are subject to market risks. Read all scheme
            related documents carefully.
          </p>
          <p>
            AMFI Registered Mutual Fund Distributor | {{ ARNNo }} | Initial Date
            of ARN Registration : {{ FromDate }} | Validity Expiry of ARN :
            {{ ToDate }}
          </p>

          <p class="disclaimer-text hide">
            Mutual fund investments are subject to market risks. Read all scheme
            related documents carefully.
          </p>

          <p class="licenseNo hide">
            AMFI Registered Mutual Fund Distributor | {{ ARNNo }}
          </p>
          <address>
            Content Disclaimer: The information on Mutual Funds available on
            this platform is sourced from AMFI.
          </address>
          <!-- <address>Mutual Fund investments are subject to market risks. Read all scheme related documents carefully. Past performance of any scheme does not indicate its future performance.</address> -->
          <address class="">
            <p class="licenseNo Privacy">
              <a
                class="licenseNo Privacy"
                routerLinkActive="Active"
                routerLink="/siteDisclaimer">
                Disclaimer
              </a>
              |
              <a
                class="licenseNo Privacy"
                routerLinkActive="Active"
                routerLink="/privacy_policy">
                Privacy Policy
              </a>
            </p>
          </address>
        </div>
      </div>
    </div>
  </div>
</footer>
